import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row} from "react-bootstrap";
import { Tooltip } from 'react-tooltip'
import { BiHelpCircle } from "react-icons/bi";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import configInfo from '../config/config.json';
import { translateAPIError } from '../utils/apiUtils';


const NotifTypeAdmin_NewNotifTypeView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

/*
  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    name: '',
    description: '',
    category: '',
  //timeBased: true,
    status: '',
    emailSubject: '',
    emailBody: '',
    smsBod: ''
  });
*/
  const [objAttrs, setObjAttrs] = useState({
  });

  const [enableEmail, setEnableEmail] = useState(false);
  const [enableSMS,   setEnableSMS]   = useState(false);

  const categoryOptions = [
    { key: "ALARM",     value: "ALARM" },
  //{ key: "WORKORDER", value: "WORKORDER" },
    { key: "NOTICE",    value: "NOTICE" },
    { key: "AI_RECOMM", value: "AI_RECOMM" },
    { key: "OTHER",     value: "OTHER" }
  ];

  const statusOptions = [
    { key: "ST_ENABLED",  value: "ST_ENABLED" },
    { key: "ST_DISABLED", value: "ST_DISABLED" }
  ];

  const [alarmMsgTemplate, setAlarmMsgTemplate] = useState();


  // Initialize state
  useEffect(() => {

    setErrMsg('');

    if (   configInfo.uiConfig.visibleFields.NOTIFTYPE_Email_Template
        || configInfo.uiConfig.visibleFields.NOTIFTYPE_SMS_Template) {
      fetchMsgTempl();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function fetchMsgTempl() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("business-configs?name=DEFAULT_NOTIF_MSG_TEMPLATE");

        resolve(res.data);

        if (res.status === 200) {
          if (res.data[0] && res.data[0].config) {
            setAlarmMsgTemplate(res.data[0].config.alarmMsgTemplate);
          } else {
            setErrMsg(t("I18N_ERR_fetch_alarm_msg_templ"));
          }
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t("I18N_ERR_fetch_alarm_msg_templ") +
                    " (" + t(translateAPIError(error)) + ").");
        }
      }
    });
  }

  // UI Functions

  const [errMsg, setErrMsg] = useState('AAA');

  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

/*
  const onCheckboxSelectNew = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.checked });
  }
*/

  const onCategorySelect = (key, event) => {
    // Deep copy
    let tmpAttrs =  JSON.parse (JSON.stringify(objAttrs));
    tmpAttrs.category = key;

    // Supply default template info for alarm type
    if (   (key === 'ALARM')
        && (   configInfo.uiConfig.visibleFields.NOTIFTYPE_Email_Template
            || configInfo.uiConfig.visibleFields.NOTIFTYPE_SMS_Template)) {

      if (!tmpAttrs.emailSubject || (tmpAttrs.emailSubject.length === 0))
        tmpAttrs.emailSubject = (alarmMsgTemplate && alarmMsgTemplate.email) ? alarmMsgTemplate.email.subject : '';

      if (!tmpAttrs.emailBody    || (tmpAttrs.emailBody.length === 0))
        tmpAttrs.emailBody    = (alarmMsgTemplate && alarmMsgTemplate.email) ? alarmMsgTemplate.email.body    : '';

      if (!tmpAttrs.smsBody      || (tmpAttrs.smsBody.length === 0))
        tmpAttrs.smsBody      = (alarmMsgTemplate && alarmMsgTemplate.sms)   ? alarmMsgTemplate.sms.body      : '';
    }

    setObjAttrs(tmpAttrs);
  }

  const onStatusSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, status: key });
  }


  const handleSubmit = (e) => {
    e.preventDefault();

    setErrMsg(t(''));

    // Validate parameters
    if (!objAttrs.name || objAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
      return;
    } else if (objAttrs.name.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 50);
      return;
    } else if (!objAttrs.description || objAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
      return;
    } else if (objAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
      return;
    } else if (!objAttrs.status || objAttrs.status.length === 0) {
      setErrMsg(t("I18N_ERR_Need_status"));
      return;
    } else if (!objAttrs.category || objAttrs.category.length === 0) {
      setErrMsg(t("I18N_ERR_Need_category"));
      return;
    }

    // Validate and process template info
    if (   enableEmail
        && (   !objAttrs.emailSubject
            || (objAttrs.emailSubject.length === 0)
            || !objAttrs.emailBody
            || (objAttrs.emailBody.length === 0))) {
      setErrMsg(t("I18N_Need_email_tmpl_data"));
      return;
    }

    if (   enableSMS
        && (   !objAttrs.smsBody
            || (objAttrs.smsBody.length === 0))) {
      setErrMsg(t("I18N_Need_sms_tmpl_data"));
      return;
    }

    objAttrs.msgTemplates = {
      email: {},
      sms: {}
    }

    objAttrs.msgTemplates.email.enabled = enableEmail;
    objAttrs.msgTemplates.email.subject = enableEmail ? objAttrs.emailSubject : '';
    objAttrs.msgTemplates.email.body    = enableEmail ? objAttrs.emailBody    : '';

    objAttrs.msgTemplates.sms.enabled   = enableSMS;
    objAttrs.msgTemplates.sms.body      = enableSMS   ? objAttrs.smsBody      : '';

    objAttrs.timeBased = true;  // ### Hard coded ###
    objAttrs.attrList  = '';    // ### Hard coded ###

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(objAttrs));

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("notif-types", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Notiftype")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Notiftype_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Name")}: *</Col>
              <Col md={3}>{t("I18N_Description")}: *</Col>
{/* Removed this feature.  Always time based.
              <Col md={3}>{t("I18N_Time_based")}: *</Col>
*/}
              <Col md={3}>{t("I18N_Notif_type_cat")}: *</Col>
              <Col md={3}>
              </Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={objAttrs.name}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={objAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
{/* Removed this feature.  Always time based.
              <Col md={3}><Form.Check type="switch" name={"timeBased"} checked={objAttrs.timeBased}
                   onChange={onCheckboxSelectNew} />
              </Col>
*/}
              <Col md={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!objAttrs.category ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("I18N_" + categoryOptions.find( ({ key }) => key === objAttrs.category ).value)}
                  onSelect={onCategorySelect}>
                  {categoryOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col md={3}>
              </Col>
            </Row>


            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Status")}: *</Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!objAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("I18N_" + (statusOptions.find( ({ key }) => key === objAttrs.status )).value)}
                  onSelect={onStatusSelect}>
                  {statusOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
            </Row>

            { configInfo.uiConfig.visibleFields.NOTIFTYPE_Email_Template || configInfo.uiConfig.visibleFields.NOTIFTYPE_SMS_Template ?
              <>
                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    <Col sm={{span: 12}}>
                      {t("I18N_Msg_templates")}: *
                      <span style={{marginLeft:'5px'}} data-tooltip-id="my-tooltip" data-tooltip-html={t("I18N_TIP_Notif_template_var")} >
                        <BiHelpCircle size={14} />
                      </span>
                      <Tooltip id="my-tooltip" />
                    </Col>
                </Row>

                <div style={{marginLeft: '0px', marginTop: '5px', padding: '10px', border:'1px solid #AAA', borderRadius:'5px' }}>

                  {/* --- Email --- */}

                  <Row className={classes.admin_pages__field_label} >
                    <Col sm={1} style={{ fontSize:'13px', textDecorationLine: 'underline' }} >{t("I18N_Email")}</Col>
                    <Col sm={11}>
                      <Form className={classes.admin_pages__field_value} style={{margin:'0px 0 0 -1px'}}>
                        <Form.Check
                          type="switch" id="email"
                          label={t("I18N_Enabled")} checked={enableEmail}
                          onChange={() => { setEnableEmail(!enableEmail) }}
                        />
                      </Form>
                    </Col>
                  </Row>

                  { enableEmail ?
                    <>
                      <Row className={classes.admin_pages__field_label} style={{ marginTop: '8px' }}>
                        <Col sm={1}>{t("I18N_Subject")}:</Col>
                        <Col sm={11}>
                          <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="emailSubject"
                            value={objAttrs.emailSubject ? objAttrs.emailSubject : ''}
                            onChange={(e) => onAttrsInputChange(e)} />
                        </Col>
                      </Row>
                      <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                        <Col sm={{span: 1}}>{t("I18N_Msg_body")}:</Col>
                        <Col sm={{span: 11}}>
                          <textarea rows={6} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="emailBody"
                                    value={objAttrs.emailBody ? objAttrs.emailBody : ''}
                                    onChange={(e) => onAttrsInputChange(e)} />
                        </Col>
                      </Row>
                    </>
                  : null
                  }

                  {/* --- SMS --- */}

                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '15px' }} >
                    <Col sm={1} style={{ fontSize:'13px', textDecorationLine: 'underline' }} >{t("I18N_SMS")}</Col>
                    <Col sm={11}>
                      <Form className={classes.admin_pages__field_value} style={{margin:'0px 0 0 -1px'}}>
                        <Form.Check
                          type="switch" id="sms"
                          label={t("I18N_Enabled")} checked={enableSMS}
                          onChange={() => { setEnableSMS(!enableSMS) }}
                        />
                      </Form>
                    </Col>
                  </Row>

                  { enableSMS ?
                      <Row className={classes.admin_pages__field_label} style={{ marginTop: '8px' }}>
                        <Col sm={1}>{t("I18N_Msg_body")}:</Col>
                        <Col sm={11}>
                          <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="smsBody"
                            value={objAttrs.smsBody ? objAttrs.smsBody : ''}
                            onChange={(e) => onAttrsInputChange(e)} />
                        </Col>
                      </Row>
                  : null
                  }
                </div>
              </>
            : null
            }

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}

export default NotifTypeAdmin_NewNotifTypeView;
